// WebWalletAdapter — ONLINE implementation of WalletPort.
// Issues the EXACT same HTTP requests the game used before the platform layer:
//   GET  <apiBase>/<gameSlug>/config   (withCredentials)
//   POST <apiBase>/<gameSlug>/spin     (withCredentials, 20s timeout)
// Responses are passed through unchanged. Errors are re-thrown as-is so callers
// can inspect err.response.status (401 / 402 / 503) exactly as before.

import axios from 'axios';
import { WalletPort } from './walletPort';

export class WebWalletAdapter extends WalletPort {
  constructor({ apiBase, gameSlug }) {
    super();
    this._api = apiBase;     // e.g. https://host/api
    this._slug = gameSlug;   // e.g. 'lucky-ducky'
  }

  get mode() { return 'online'; }

  async getConfig() {
    const { data } = await axios.get(
      `${this._api}/${this._slug}/config`,
      { withCredentials: true },
    );
    return data;
  }

  async placeSpin({ client_request_id, wager_key }) {
    const { data } = await axios.post(
      `${this._api}/${this._slug}/spin`,
      { client_request_id, wager_key },
      { withCredentials: true, timeout: 20000 },
    );
    return data;
  }

  async getBalance() {
    const cfg = await this.getConfig();
    return cfg.balance_dollars;
  }

  // Web wallet has no physical credit in/out — loads & cashouts use the normal
  // site flows, not the game. Explicitly unsupported here.
  // eslint-disable-next-line class-methods-use-this
  async creditIn() {
    throw new Error('creditIn is a machine (kiosk) operation; not available online');
  }

  // eslint-disable-next-line class-methods-use-this
  async creditOut() {
    throw new Error('creditOut is a machine (kiosk) operation; not available online');
  }
}
